module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-57c74639!./packages/dof-minibar/colmo.css
// module id = 488
// module chunks = 0 1